function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "g9h9a",
  d: "M1519 872.499v3.67a.782.782 0 0 1-.028.204c-.08.36-.425.631-.834.631h-16.282c-.436 0-.798-.308-.844-.7-.012-.047-.012-.089-.012-.14v-3.67c0-.434.385-.784.85-.784.232 0 .448.089.6.23.154.141.25.34.25.553v2.94h14.605v-2.94c0-.433.385-.783.85-.783.232 0 .448.089.6.23a.791.791 0 0 1 .245.559z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g9h9b",
  d: "M1515.532 868.213l-4.261 4.236c-.005.011-.017.017-.024.023a1.007 1.007 0 0 1-.56.282c-.018 0-.035.005-.053.005-.034.006-.07.006-.104.006l-.098-.006c-.017 0-.034-.005-.053-.005a.99.99 0 0 1-.56-.282l-.024-.023-4.26-4.236a1.001 1.001 0 0 1-.295-.713c0-.259.098-.518.294-.713a1.023 1.023 0 0 1 1.434 0l2.56 2.545.003-9.326a1.014 1.014 0 0 1 1.729-.713.99.99 0 0 1 .294.713v9.327l2.561-2.545a1.023 1.023 0 0 1 1.434 0 1.025 1.025 0 0 1-.018 1.425z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1501 -859)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#2e2c47",
  fillOpacity: 0.77,
  xlinkHref: "#g9h9a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1501 -859)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#2e2c47",
  fillOpacity: 0.77,
  xlinkHref: "#g9h9b"
})));

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-icon.64e6a2c5.svg";
export { ForwardRef as ReactComponent };